/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ControlContainer} from '@angular/forms';

/** Updates a named form-level error, or marks the form pending when validity is not known yet. */
export function setFormValidity(
  container: ControlContainer | null | undefined,
  key: string,
  isValid?: boolean
): void {
  const control = container?.control;
  if (!control) {
    return;
  }
  if (isValid === undefined) {
    control.markAsPending();
    return;
  }

  const errors = {...(control.errors || {})};
  if (isValid) {
    delete errors[key];
  } else {
    errors[key] = true;
  }
  control.setErrors(Object.keys(errors).length ? errors : null);
}
